module.exports = __webpack_public_path__ + "static/media/copeland.0326626d.png";